import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

export const close = (props) => {
  return <CloseRoundedIcon {...props} />;
};
